import { render } from "./validator-card.vue?vue&type=template&id=9b669af4"
import script from "./validator-card.vue?vue&type=script&lang=js"
export * from "./validator-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__